import React from "react";

export default function BlackButton(props) {
  const submitChange = () => {
    if (props.submitChange) props.submitChange();
  };
  return (
    <>
      <button
        type="button"
        class="btn orangeButton paddingbutton orangeButtonText d-flex align-items-center justify-content-center"
        onClick={submitChange}
      >
        {props.buttonText}
      </button>
    </>
  );
}
